import * as React from 'react'

function SvgSs(props) {
	return (
		<svg viewBox="0 0 20 10" width="1em" height="1em" {...props}>
			<path fill="#078930" d="M0 0h20v10H0z" />
			<path fill="#FFF" d="M0 0h20v7H0z" />
			<path d="M0 0h20v3H0z" />
			<path fill="#DA121A" d="M0 3.5h20v3H0z" />
			<path fill="#0F47AF" d="M0 0l8.66 5L0 10z" />
			<path fill="#FCDD09" d="M1.287 5l2.894.94-1.789-2.462v3.044l1.79-2.462z" />
		</svg>
	)
}

export default SvgSs
